import React from 'react';
import STRINGS from '@utils/strings';
import { getAssetMintNumber } from '@api/api';
import Select from 'react-select/creatable';

const MultiSelect = ({ value, options, limit, setSelectedOptions }) => {
    return (
        <Select
            value={value}
            isMulti
            onChange={setSelectedOptions}
            options={options}
            getOptionLabel={option => getAssetMintNumber(option)}
            getOptionValue={option => option.asset_id}
            placeholder={STRINGS.selectMintNumbers}
            isOptionDisabled={() => value && value.length >= limit}
        />
    );
};

export default MultiSelect;
